import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IPictureListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
}
export const fetchPictureList = async (
  payload: IPictureListInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/category/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}`
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IPictureInsert {
  mimetype: string;
  seofilename: string;
  altattribute: string;
  titleattribute: string;
  virtualpath: string;
  originalfilename: string;
  filesize: number;
  visible: boolean;
  filetype: number;
  filecontenttype: number;
}

export const insertPicture = async (payload: {
  documents: IPictureInsert[];
}): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/picture`,
    {
      body: payload,
    }
  );

  let _data: any = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface IUpdatePicturePayload {
  mimetype?: string;
  seofilename?: string;
  altattribute?: string;
  titleattribute?: string;
  isnew?: boolean;
  virtualpath?: string;
  filesize?: number;
  originalfilename?: string;
  payload?: IPicturePayload;
  filecontenttype?: number | null;
}
export const updatePicture = async (
  pictureId: number,
  payload: IUpdatePicturePayload
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/picture/${pictureId}`,
    {
      body: payload,
    }
  );
  return data;
};

export const getPicture = async (id: number): Promise<any> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/picture/${id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export const updatePictureVisibility = async (
  imageId: number,
  visible: boolean
) => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/picture/${imageId}/visibility`,
    {
      body: {
        visible,
      },
    }
  );
  return data;
};

export const deletePicture = async (imageId: number) => {
  const { data }: any = await request(
    'delete',
    `${Environment.API_BASE_URL}/api/picture/${imageId}`
  );
  return data;
};

export interface IPicturePayload {
  floor?: string;
  size?: string;
  bedrooms?: string;
  bathrooms?: string;
  additionalInfo?: string;
  filecontenttype?: number | null;
}

export interface IPictureInfo {
  id: number;
  mimetype: string;
  seofilename: string;
  altattribute: string;
  titleattribute: string;
  isnew: boolean;
  virtualpath: string;
  originalfilename: string;
  guid: string;
  filesize: number;
  uploadedon: Date;
  uploadedby: number;
  visible: boolean;
  filetype: number;
  filecontenttype: number;
  uploadedbyuser: string;
  payload: string | IPicturePayload;
}

export const getPictureInfo = async (id: number): Promise<any> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/picture/${id}/info`
  );
  const _data: IPictureInfo = data.data as IPictureInfo;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IDataCaption {
  id: number;
  caption: string;
}

export const updateCaptionImage = async (
  payload: IDataCaption[]
): Promise<any> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/picture/update-batch`,
    {
      body: {
        pictures: payload,
      },
    }
  );
  const _data: IPictureInfo = data.data as IPictureInfo;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
